<p class="most-searched__title" id="autocompleteLabel">Veelgezocht</p>
<ul aria-labelledby="autocompleteLabel" class="reset-list-styles">
  @for (query of queries(); track $index) {
    <li
      tabindex="-1"
      class="most-searched__item"
      [wlAutomationId]="'search-most-searched-' + $index"
    >
      <wl-search-suggestion [query]="query" [value]="query" />
    </li>
  }
</ul>
